const modelName = 'Cruise Line Page Details';
const modelNameSingular = 'Cruise Line Page';
const endpoint = '/cruiseline-details';

const setup = {
  title: modelName,
  singular: modelNameSingular,
  model: modelName.replace(/\s+/g, '-').toLowerCase(),
  canDelete: true,
  canAddNew: false,
  canSearch: true,
  endpoint,
  accessor: 'id',
};

export default setup;
